// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SelectedPlan_wrap__1zeD_","plan":"SelectedPlan_plan__2sobV","header":"SelectedPlan_header__1DJOR","name":"SelectedPlan_name__1Qz5C","info":"SelectedPlan_info__biGDK"};